
export const BasePageMixin = {
  data () {
    return {
    }
  },
  methods: {
    HasValue (val) {
      return val !== undefined && val !== null
    },
    SetLocalStorage (key, value) {
      // ttl - 5000 equals to 5 second - 1 hr = 60000 * 60 = 3600000
      // ttl - 5000 equals to 5 second - 1 hr = 60000 * 60 * 12 = 43,200,000
      //const ttl = 3600000
      const ttl = 43200000
      this.SetLocalStorageWithExpiration(key, value, ttl)
    },
    SetLocalStorageWithExpiration (key, value, ttl) {
      const now = new Date()

      // `item` is an object which contains the original value
      // as well as the time when it's supposed to expire
      const item = {
        value: value,
        expDate: now.getTime() + ttl,
      }
      localStorage.setItem(key, JSON.stringify(item))
    },
    GetLocalStorageWithExpiration (key) {
      const itemStr = localStorage.getItem(key)
      // if the item doesn't exist, return null
      if (!itemStr) {
        return null
      }
      const item = JSON.parse(itemStr)
      const now = new Date()
      // compare the expiry time of the item with the current time
      if (now.getTime() > item.expDate) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
      }
      return item.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/BasePageMixin.js